$('.slide-banner').owlCarousel({
	center: true,
	items:1,
	loop:true,
	dots: false,
	nav: false,
	// animateOut: 'fadeOut',
	autoplay: true,
	autoplayTimeout: 5000,
	autoplayHoverPause: true
});

var owlBanner = $('.slide-banner');
owlBanner.owlCarousel();
$('.ac-slide .next').click(function() {
	owlBanner.trigger('next.owl.carousel');
})
$('.ac-slide .prev').click(function() {
	owlBanner.trigger('prev.owl.carousel');
})

$('.slide-gallery').owlCarousel({
	center: true,
	items:1,
	loop:true,
	dots: false,
	nav: false,
	autoplay: true,
	autoplayTimeout: 4000,
	autoplayHoverPause: false
});

$('.slide-image').owlCarousel({
	center: true,
	items:1,
	loop:true,
	dots: true,
	nav: false,
	autoplay: true,
	autoplayTimeout: 5000,
	autoplayHoverPause: true
});

$('.slide-customer').owlCarousel({
	center: true,
	items:1,
	loop:true,
	dots: true,
	nav: false,
	autoplay: true,
	autoplayTimeout: 4500,
	autoplayHoverPause: true,
	responsive: {
		1200: {
			animateOut: 'fadeOut',
		}
	}
});

var owlCustomer = $('.slide-customer');
owlCustomer.owlCarousel();
$('.ac-slide-cus .next').click(function() {
	owlCustomer.trigger('next.owl.carousel');
})
$('.ac-slide-cus .prev').click(function() {
	owlCustomer.trigger('prev.owl.carousel');
})

////Menu
function openMenu(){
	$('.g-nav').addClass('active');
}

function closeMenu(){
	$('.g-nav').removeClass('active');
}

$(".open-nav").click(function(){
	openMenu();
});

$(".close-nav").click(function(){
	closeMenu();
})